import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface ClearState {
	isCleared: boolean;
	count: number;
}

const initialState: ClearState = {
	isCleared: false,
	count: 0,
};

const clearSlice = createSlice({
	name: 'clearSlice',
	initialState,
	reducers: {
		setClearedState: (state, action: PayloadAction<boolean>) => {
			state.isCleared = action.payload;
			state.count += 1;
		},
		increaseCount: (state) => {
			state.count += 1;
		},
		decreaseCount: (state) => {
			state.count -= 1;
		},
		resetClearedState: (state) => {
			state.isCleared = false;
			state.count = 0;
		},
	},
});

export const { setClearedState, increaseCount, decreaseCount, resetClearedState } = clearSlice.actions;
export default clearSlice.reducer;
